import { render } from "./CnRules.vue?vue&type=template&id=1568e84a&scoped=true"
import script from "./CnRules.vue?vue&type=script&scoped=true&lang=js"
export * from "./CnRules.vue?vue&type=script&scoped=true&lang=js"

import "./CnRules.vue?vue&type=style&index=0&id=1568e84a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1568e84a"

export default script